import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import i18n from 'i18next';

class MobMenu extends Component {
  static propTypes = {
    dataMenu: PropTypes.object,
    isShowLoader: PropTypes.bool,
    menuKeys: PropTypes.array,
    currentCategory: PropTypes.string,
  };
  constructor(props) {
    super(props);
  }

  /**
   * ucfirst
   *
   */
  ucfirst = (str) => {
    var f = str.charAt(0).toUpperCase();
    return f + str.substr(1, str.length - 1);
  };

  /**
   * Renders nested list with unlimited nested levels
   *
   *
   * @param child
   * @param nested
   * @returns {*}
   */
  renderNestedList = (child, nested = false) => {
    var language = i18n.language;
    var methodName = 'categoryName' + this.ucfirst(language);

    if (nested === true) {
      return (
        <ul className='catalog-menu__sub-list uk-list uk-margin-remove'>
          {Object.keys(child).map((keyChild) => (
            <li key={child[keyChild].data.id}>
              <Link
                to={`/products/${
                  i18n.language + '/' + child[keyChild].data.alias
                }`}
              >
                {child[keyChild].data[methodName]}
              </Link>
              {this.renderNestedList(child[keyChild].child, true)}
            </li>
          ))}
        </ul>
      );
    } else {
      if (Object.keys(child.child).length === 0) {
        return (
          <li key={child.data.id}>
            <Link to={`/products/${i18n.language + '/' + child.data.alias}`}>
              {child.data[methodName]}
            </Link>
          </li>
        );
      }
      if (Object.keys(child.child).length > 0) {
        return (
          <li className='uk-parent' key={child.data.id}>
            <Link
               className='catalog-menu__sub-list uk-nav-parent-icon uk-nav'
              //className='mob-header__menu-sub-nav-link'
              // className={
              //   this.props.currentCategory === child.data.alias
              //     ? ' mob-header__menu-sub-nav-link uk-nav-parent-icon'
              //     : ' mob-header__menu-sub-nav-link active uk-nav-parent-icon '
              // }
              to={`/products/${i18n.language + '/' + child.data.alias}`}
            >
              {child.data[methodName]}
            </Link>
            <ul
              className='catalog-menu__sub-list uk-nav-parent-icon uk-nav'
              uk-nav={''}
            >
              {Object.keys(child.child).map((key) => (
                <li
                  key={`catmenu_${key}`}
                  className={
                    Object.keys(child.child[key].child).length > 0
                      ? 'uk-parent'
                      : ''
                  }
                >
                  <Link
                    className={
                      this.props.currentCategory === child.data.alias
                        ? ' mob-header__menu-sub-nav-link '
                        : '  active'
                    }
                    to={`/products/${
                      i18n.language + '/' + child.child[key].data.alias
                    }`}
                  >
                    {child.child[key].data[methodName]}
                  </Link>
                  {this.renderNestedList(child.child[key].child, true)}
                </li>
              ))}
            </ul>
          </li>
        );
      }
    }
  };

  /**
   * Renders menu
   *
   * @returns {*}
   */
  render() {
    return (
      <>
        {this.props.isShowLoader === false ? (
          <ul
            className='mob-header__menu-sub-nav uk-nav-sub catalog-menu__sub-list uk-nav-parent-icon uk-nav  uk-nav-parent-icon'
            uk-nav={''}
            hidden={this.props.showCatalog}
          >
            {this.props.menuKeys.map((key, inc) => (
              // <div key={`menuKeys_${key}`}>
                this.renderNestedList(this.props.dataMenu[key])
              // </div>
            ))}
          </ul>
        ) : (
          <div>......</div>
        )}
      </>
    );
  }
}

const mapStateToProps = (store) => {
  const { dataMenu, isShowLoader } = store.menu;
  return {
    menuKeys: Object.keys(dataMenu),
    dataMenu: dataMenu,
    isShowLoader: isShowLoader,
  };
};

export default connect(mapStateToProps)(MobMenu);
